import hassle from '../../assets/Images/Choosecard/Hassle-free.png'
import group from '../../assets/Images/Choosecard/Group.png'
import customer from '../../assets/Images/Choosecard/Customer support.png'
import middle from '../../assets/Images/Choosecard/No middle-men.png'
import Verified from '../../assets/Images/Choosecard/Verified listing.png'
import Boost from '../../assets/Images/Choosecard/Boost.png'


export const carddata = [
    {
        img: hassle,
        name:"Hassle-Free Searching",
        para:"Say goodbye to tedious property searches. Our intuitive platform allows effortless filtering for hassle-free results.",
    },
    {
        img:group,
        name:"Direct Communication",
        para:"Linked Bricks enables direct communication with landlords for questions, negotiations, and transparent experiences.",
    },
   
  
    {
        img: Verified,
        name:"Verified Listings",
        para:"Browse with confidence – Linked Bricks verifies all listings for your safety and quality assurance.",
    },
    {
        img:Boost,
        name:"Local Market Insights",
        para:"Get informed with local market insights on property trends, prices, and neighborhoods for confident decisions.",
    },
    {
        img: middle,
        name:"No Middlemen",
        para:"Linked Bricks eliminates intermediaries, granting you more control for faster, direct real estate interactions and decisions.",
    },
   
    {
        img:customer,
        name:"Dedicated Customer Support:",
        para:"Our dedicated customer support team is ready to assist you at every step of your property search journey.",
    },
]